<template>
  <main class="home">
    <div class="section__trabajo">
      <div class="work">
        <div class="content">
          <div class="info">
            <div class="content">
              <div class="controllers">
                <font-awesome-icon :icon="['far', 'times-circle']" size="lg" class="icon" @click="closeBoard"/>
              </div>
              <h1 class="title">{{trabajo.name}}</h1>
              <p class="paragraph">{{trabajo.text}}</p>
              <a class="behance" v-if="trabajo.behanceUrl" :href="trabajo.behanceUrl" target="_blank">
                <font-awesome-icon :icon="['fab', 'behance']" size="lg" class="icon"/>
              </a>
            </div>
          </div>
          <div class="board" id="coso">
            <div class="board__item" v-for="(item, index) in trabajo.board" :key="index">
              <img v-lazy="item.url" v-if="item.type === 'img'">
              <div class="vid" v-if="item.type === 'vid'">
                <div class="content" v-html="item.url"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  created () {
    this.$store.commit('setOpenedItem', this.workName)
  },
  watch: {
    'workName': function () {
      this.$store.commit('setOpenedItem', this.workName)
    }
  },
  props: ['workName'],
  methods: {
    closeBoard () {
      this.$router.push('/')
      setTimeout(() => {
        document.querySelector('.section__portfolio').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }, 100)
    }
  },
  computed: {
    trabajo () {
      return this.$store.state.openedItem
    },
    parallaxBackground () {
      if (this.$store.state.windowWidth >= 768) {
        return `background-position: center ${this.$store.state.scrollY * 0.5}px`
      }
    }
  }
}
</script>
